import React from 'react'

interface Props {
    toggleCoverActive: (params: boolean) => void
    send: (msg: string, payload: string, options?: object) => void
    coverOptions: any
    dataset: any
    mainSizing: {
        width: string
        height: string
        menuOverlayHeight: string
    }
}

export const AscCoverPage: React.FC<Props> = ({ toggleCoverActive, dataset, coverOptions, send, mainSizing}: Props) => {
    const { width, menuOverlayHeight } = mainSizing
    const {
        cover_page_background_color,
        cover_page_text_color,
        cover_page_start_btn_color,
        cover_page_start_btn_text_color,
        cover_page_hyperlink_color,
        header_bg_color,
        big_bot_avatar_url,
        terms_link,
    } = dataset

    const { options } = coverOptions

    const coverPageTitle = sessionStorage.getItem('custom_cover_page_title')
    const coverPageText = sessionStorage.getItem('custom_cover_page_text')
    const coverPageButtonText = sessionStorage.getItem('custom_cover_page_btn_text')

    const onSubmit = () => {
        const messageAndPayload = options.split('||')
        toggleCoverActive(false)
        send(messageAndPayload[0], '/submitCoverpage', {clearKeywords: true, clearNextPayload: true})
    }

    return (
        <div
            className='coverPageHolder'
            style={{ 
                width: 'calc(100% - 30px)', 
                height: `calc(100% - 60px)`,
                color: cover_page_text_color,
                backgroundColor: cover_page_background_color,
            }}
        >
            <div className='coverPageImgHolder'><img src={big_bot_avatar_url} className='coverPageImg' style={{borderRadius: '100%'}}/></div>
            {coverPageTitle && <b className='coverPageHeader'>{coverPageTitle}</b>}
            {coverPageText && <div className='coverPageText'>{coverPageText}</div>}
            {terms_link && <div className='coverPageText'>Find out more about me 
                <a style={{color: cover_page_hyperlink_color, display: 'inline', paddingLeft: '4px'}} href={terms_link} target="_blank" rel="noreferrer">here</a>
                .</div>}
            <div className='coverPageButtonContainer'>
                <button
                    onClick={() => onSubmit()}
                    className='coverPageSubmitButton'
                    style={{ color: cover_page_start_btn_text_color, backgroundColor: cover_page_start_btn_color }}
                >
                    {coverPageButtonText ? coverPageButtonText : 'Get Started'}
                </button>
            </div>
        </div>
    )
}
